<app-data-import type="assets"></app-data-import>
